import Swiper from 'swiper/dist/js/swiper'
import mainOptions from './sliderOptions';

const infoSlider = (wrapper) => {
  const mainSliderEl = wrapper.querySelector('.js-info-slider-main');
  const slides = Array.prototype.slice.call(mainSliderEl.querySelectorAll('.swiper-slide'));
  const slidesLength = slides.length;
  const pagination = wrapper.querySelector('.swiper-pagination');
  const prev = wrapper.querySelector('.js-swiper-button-prev');
  const next = wrapper.querySelector('.js-swiper-button-next');

  return new Swiper(mainSliderEl, mainOptions({
    threshold: 8,
    slidesLength,
    prev,
    next,
    pagination
  }));

};
export default infoSlider;
